export const AEM_PLATFORM_NAMES = {
    CHROME_NAME: 'Chrome',
    EDGE_NAME: 'Edge',
    IOS_EDGE_TABLET_NAME: 'Ios Edge Tablet',
    SAFARI_NAME: 'Safari',
    IOS_SAFARI_NAME: 'Ios Safari',
    IOS_SAFARI_TABLET_NAME: 'Ios Safari Tablet',
    IOS_CHROME_NAME: 'Ios Chrome',
    IOS_CHROME_TABLET_NAME: 'Ios Chrome Tablet',
    BLUEFY_NAME: 'Bluefy',
    BLUEFY_TABLET_NAME: 'Bluefy Tablet',
    DEFAULT: 'Default',
    DEFAULT_TABLET: 'Default Tablet',
    DEFAULT_MOBILE: 'Default Mobile',
};
